import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";
import "./NavMenu.css";
import contact from '../Images/contact.jpg'
import * as React from "react";

import {
  Collapse,
  Container,
  Dropdown,
  DropdownButton,
  FormControl,
  Nav,
  NavDropdown,
  NavItem,
  NavLink,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  OverlayTrigger,
  Popover
} from 'react-bootstrap';
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MainContext } from "../store/mainContext";
//import ReportFuelSeason from './ReportFuelSeason'
import { UserContext } from "../store/userContext";
import http from "../Services/httpService";
import config from "../config.json";
export default function NavMenu() {



  const { connection, state, reconnection } = useContext(UserContext);
  const { devices, changed, doChanged, setDefaultDevice, setRoutePoint, command, setCommand } = useContext(MainContext);


  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      className="nav-link px-3"
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
      {/*&#x25bc;*/}
    </a>
  ));



  return (
    <>

      <Navbar bg="light" expand="lg" className=" " variant="light" id="navTop">
        <Container fluid>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" >امکانات</Navbar.Toggle>
          <Navbar.Collapse id="responsive-navbar-nav" >{/*style={{display:(isOpen?"block":"none")}} */}
            {/*
            <div className="navbar-nav" >
              <div className="nav-item text-nowrap">
                <a className="nav-link px-3" href="/main">
                  <span className="navbarIcon" >🗺️</span>
                  نقشه خیابان
                </a>
              </div>
            </div>
            */
            }
            <Dropdown className="navbar-nav"
              onSelect={eventKey => {
                noronServices.hideMenu();
                if (eventKey == -1) {
                  setCommand("AddDeviceUser");
                  return;
                }
                setCommand(`EditDeviceShow/${eventKey}`);
              }}
            >
              <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                <span className="navbarIcon" >🚗</span> ردیاب
              </Dropdown.Toggle>
              <Dropdown.Menu id="dd" className="myDropDown">
                <Dropdown.Item key={"drop0"} eventKey={-1}>
                  <div className="btn btn-primary">اضافه کردن ردیاب</div>
                </Dropdown.Item>
                {devices.map((item, index) => (

                  <div aria-selected="false" key={index} data-rr-ui-dropdown-item="" className="dropdown-item d-flex">
                    <Link className="customItemMenu w-100 "
                      to="/"
                      style={{ textDecoration: "none" }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        noronServices.hideMenu();;
                        setDefaultDevice({ ...item, dd: Date.now() });
                      }}>
                      {item.icon != "" && <img src={`${config.apiUrl}/piccar/${item.icon}`} className="imgDeviceMenu" />}
                      <span className="p-2">{item.deviceName}</span>
                    </Link>
                    <button className="btn btn-secondary p-2 btn-sm" onClick={(e) => {
                      e.preventDefault();
                      noronServices.hideMenu();;
                      //setDevice(item);
                      //setEditDeviceShow(true);
                      setCommand(`EditDeviceShow/${item.id}`);
                      return false;
                    }}>ویرایش</button>
                  </div>

                ))}
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown className="navbar-nav"
              onSelect={eventKey => {
                noronServices.hideMenu();;
                if (eventKey == 1) {
                  setCommand("ShowChangePassword");
                  return;
                } else if (eventKey == 2) {
                  setCommand("ShowChangeProfile");
                  return;
                }
                else if (eventKey == 3) {
                  setCommand("ShowCredit");
                  return;
                }
                else if (eventKey == 4) {
                  setCommand("ShowUserAccounts");
                  return;
                }
              }}
            >
              <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                <span className="navbarIcon" >⚙️</span>تنظیمات کاربری
              </Dropdown.Toggle>
              <Dropdown.Menu className="myDropDown">
                <Dropdown.Item eventKey={1}>تغییر رمز عبور     </Dropdown.Item>
                <Dropdown.Item eventKey={2}>تغییر مشخصات</Dropdown.Item>
                <Dropdown.Item eventKey={3}>تمدید اعتبار</Dropdown.Item>
                <Dropdown.Item eventKey={4}>کاربران زیر مجموعه</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>


            <div className="navbar-nav">
              <div className="nav-item text-nowrap">
                <Link className="nav-link px-3" to="/" onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  setCommand("OilChangeShow");
                }} >
                  <span className="navbarIcon" >🛠️</span>سرویس خودرو
                </Link>
              </div>
            </div>

            <div className="navbar-nav">
              <div className="nav-item text-nowrap">
                <Link className="nav-link px-3" to="/" onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  setCommand(`ShowReport`);
                }} >
                  <span className="navbarIcon" >📊</span>گزارش گیری
                </Link>
              </div>
            </div>

            <div className="navbar-nav">
              <div className="nav-item text-nowrap">
                <Link className="nav-link px-3" to="/fff" onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}>
                  <OverlayTrigger
                    trigger="click"
                    rootClose="true"
                    placement='bottom'
                    overlay={
                      <Popover id={`popover-positioned-bottom`}>
                        <Popover.Body>
                          <Link to="/" onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            reconnection()
                          }}>کانکت مجدد</Link>
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <span className={" badge rounded-pill " + (state == "Connected" ? "bg-success" :
                      state == "Disconnected" ? "bg-danger" : "bg-warning")}>
                      {state ? state : "نامشخص"}
                    </span>

                  </OverlayTrigger>
                </Link>
              </div>
            </div>

          </Navbar.Collapse>
          <div>

            <NavDropdown
              title={<>
                <img src={contact} className="imgMenuProfile" id="imgMenuProfile" />
              </>}
              className="text-dark"
              drop="start"
              onSelect={eventKey => {
                noronServices.hideMenu();;
                if (eventKey == -1) {
                  setCommand("logout");
                } else if (eventKey == 1) {
                  //CheckVersion();
                }

              }}>
              <NavDropdown.Item eventKey={-1} className=''>
                🔹{/* <img src={logOut} className="navbarIcon" />*/}
                خروج
              </NavDropdown.Item> 
            </NavDropdown>
          </div>
        </Container>
      </Navbar >
    </>
  );
}
